import $foreign from "./foreign.cjs";
var parseJSONImpl = $foreign.parseJSONImpl;
export { parseJSONImpl };
